import { Action } from '@ngrx/store';

import { ErrorResponse } from '~shared/models';
import { Category } from '~app/modules/generic/models';

export enum CategoryActionTypes {
  LOAD_CATEGORY = '[Category] New Category Load',
  LOAD_CATEGORY_SUCCESS = '[New Category] New Category Load Success',
  LOAD_CATEGORY_FAILURE = '[New Category] New Category Load Failure',
  CLEAR_CATEGORY = '[New Category] New Category Clear',
}

export class LoadCategory implements Action {
  type = CategoryActionTypes.LOAD_CATEGORY;

  constructor(public payload: { slug: string }) {
  }
}

export class LoadCategorySuccess implements Action {
  type = CategoryActionTypes.LOAD_CATEGORY_SUCCESS;

  constructor(public payload: Category) {

  }
}

export class LoadCategoryFailure implements Action {
  type = CategoryActionTypes.LOAD_CATEGORY_FAILURE;

  constructor(public payload: { error: ErrorResponse }) {

  }
}

export class ClearCategory implements Action {
  type = CategoryActionTypes.CLEAR_CATEGORY;
}

export type CategoryActionsUnion = LoadCategory | LoadCategorySuccess | LoadCategoryFailure;


